import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=27ac6660&"
import script from "./EventPreview.vue?vue&type=script&lang=ts&"
export * from "./EventPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports